import React from 'react';
import {
    Flex,
    FlexProps,
    Box,
    Image,
    HStack,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Text,
} from '@chakra-ui/react';

import Icon from '@/components/Icon';
import Logo from '@/images/jovelogo.svg';
import { useAuth } from '@/context/AuthContext';
import { useLeavePageConfirmation } from '@/hooks/useLeavePageConfirmation';

interface MobileProps extends FlexProps {
    onOpen: () => void;
}

// Cast via unknown so TS does not expand Chakra's polymorphic prop unions.
const NavFlex = Flex as unknown as React.FC<Record<string, unknown>>;
const NavImage = Image as unknown as React.FC<Record<string, unknown>>;
const NavBox = Box as unknown as React.FC<Record<string, unknown>>;
const NavHStack = HStack as unknown as React.FC<Record<string, unknown>>;
const NavText = Text as unknown as React.FC<Record<string, unknown>>;

export const MobileNav = ({ onOpen, ...rest }: MobileProps) => {
    const { handleLogout, user } = useAuth();
    const { shouldPreventLeaving } = useLeavePageConfirmation();
    const onLogout = () => {
        if (shouldPreventLeaving) return;
        handleLogout();
    };
    return (
        <NavFlex
            px={4}
            height="16"
            alignItems="center"
            bg={'gray.900'}
            borderBottomWidth="1px"
            borderBottomColor={'gray.200'}
            justifyContent={{ base: 'space-between', lg: 'flex-end' }}
            {...rest}
        >
            <NavBox
                onClick={onOpen}
                aria-label="open menu"
                color={'#ffffff'}
                display={{ base: 'flex', lg: 'none' }}
            >
                <Icon icon="bars" />
            </NavBox>

            <NavImage
                display={{ base: 'flex', lg: 'none' }}
                src={Logo}
                alt="jove logo"
                height={'44px'}
            />

            <NavHStack spacing={{ base: '0', lg: '6' }}>
                <Flex alignItems={'center'}>
                    <Menu>
                        <MenuButton
                            py={2}
                            transition="all 0.3s"
                            color={'#ffffff'}
                            _focus={{ boxShadow: 'none' }}
                        >
                            <NavHStack cursor="pointer">
                                <NavText>
                                    {user?.firstName} {user?.lastName}
                                </NavText>

                                <NavBox display={{ base: 'none', lg: 'flex' }}>
                                    <Icon icon="chevron-down" />
                                </NavBox>
                            </NavHStack>
                        </MenuButton>
                        <MenuList bg={'#ffffff'} borderColor={'#ffffff'}>
                            <MenuItem onClick={onLogout}>Sign out</MenuItem>
                        </MenuList>
                    </Menu>
                </Flex>
            </NavHStack>
        </NavFlex>
    );
};
